import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { KanbanBoard } from 'components/molecules/kanban-board/kanban-board';
import { RootState } from 'data';
import { FieldsStore } from 'stores/fields';
import { GroupedFilter } from '../tasks/grouped-filter-popover';
import { Item } from './group-by';
import { BoardLoading } from './loading';

const Container = styled.div`
  position: relative;
  width: 100%;
`;

const excludedTaskFields = [
  'taskId',
  'taskDescription',
  'type',
  'isCsatEnabled',
];

interface TaskKanbanBordProps {
  loading: boolean;
  groupBy: {
    rowGroup: string | null;
    columnGroup: string;
  };
  isColumnHidden?: boolean;
  filter: GroupedFilter;
  groupByItems: Item[];
}

export const AllTasksKanbanBoard: FC<TaskKanbanBordProps> = ({
  loading,
  groupBy: { columnGroup: selectedColumnField, rowGroup: selectedRowField },
  isColumnHidden,
  filter,
  groupByItems,
}) => {
  const fieldsStore = useSelector(({ fields }: RootState) => fields);
  const fields = useMemo(
    () =>
      FieldsStore.enabledTaskFields(fieldsStore).filter(
        ({ fieldName }) => !excludedTaskFields.includes(fieldName),
      ),
    [fieldsStore],
  );

  return (
    <Container>
      {loading ? (
        <BoardLoading />
      ) : (
        <KanbanBoard
          isColumnHidden={isColumnHidden}
          fields={fields}
          selectedColumnField={selectedColumnField}
          selectedRowField={selectedRowField}
          filter={filter}
          groupByItems={groupByItems}
        />
      )}
    </Container>
  );
};
